import { Component } from '@angular/core';

@Component({
    selector: 'meatballs-menu',
    templateUrl: 'meatballs-menu.component.html',
    styleUrls: ['meatballs-menu.component.less']
})
export class MeatballsMenuComponent {
}
